module.exports = __webpack_public_path__ + "img/our-client-feedback-img-1.25210afb.png";